module.exports = __webpack_public_path__ + "src/img/printing.aa8d6b27.svg";